import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';

import YearsButtons from 'inventory-listing/components/ListingFilters/Components/ListingFiltersYears/ListingFiltersYearsButtons/YearsButtons/YearsButtons.jsx';
import ListingFiltersYearsButtonsService from 'inventory-listing/components/ListingFilters/Components/ListingFiltersYears/ListingFiltersYearsButtons/ListingFiltersYearsButtonsService.js';

class ListingFiltersYearsButtons extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.resetSettings = this.resetSettings.bind(this);

        const years = ListingFiltersYearsButtonsService.getInitModels(props.years, props.contextYear);
        this.state = {
            years,
        };
    }

    componentWillReceiveProps(nextProps) {
        const years = ListingFiltersYearsButtonsService.getInitModels(nextProps.years, nextProps.contextYear);

        this.setState({ years });
    }

    updateSelectedValues(yearModels) {
        const { selectedMin, selectedMax } = ListingFiltersYearsButtonsService.getSelectedValues(yearModels);

        // Warning, each time we do an updateVehicleCriteria(), we get a new set of years
        // To avoid losing the state of the button "isClicked" the parent
        // check if the value of years is the same of as before. If not, the
        // props of years is not updated so we can keep the status of "isClicked"
        // TODO: manage the state in redux and do not update the years when we
        // do updateVehicleCriteria().
        this.props.updateVehicleCriteria(
            {
                type: 'CLOSED',
                from: selectedMin,
                to: selectedMax,
            },
            'yearRange'
        );
    }

    resetSettings() {
        const years = ListingFiltersYearsButtonsService.resetAllModels(this.state.years);

        this.updateSelectedValues(years);
        this.setState({ years });
    }

    handleChange(yearNumber) {
        const years = ListingFiltersYearsButtonsService.toggleModel(this.state.years, yearNumber);

        this.updateSelectedValues(years);
        this.setState({ years });
    }

    render() {
        if (isEmpty(this.props.years)) {
            return null;
        }
        return (
            <YearsButtons
                years={this.state.years}
                handleChange={this.handleChange}
                resetSettings={this.resetSettings}
            />
        );
    }
}

ListingFiltersYearsButtons.defaultProps = {
    years: [],
};

ListingFiltersYearsButtons.propTypes = {
    years: PropTypes.arrayOf(PropTypes.instanceOf(MetaDataModel)),
    updateVehicleCriteria: PropTypes.func.isRequired,
};

ListingFiltersYearsButtons.displayName = 'ListingFiltersYearsButtons';

export default ListingFiltersYearsButtons;
